import script from "./GnosisSession.vue?vue&type=script&setup=true&lang=js"
export * from "./GnosisSession.vue?vue&type=script&setup=true&lang=js"

import "./GnosisSession.vue?vue&type=style&index=0&id=64f1f4f6&lang=css"

const __exports__ = script;

export default __exports__